import React, { useMemo } from 'react';
import { ControllerRenderProps, Select } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import {
  WttpQuestionCategoriesDocument,
  WttpQuestionCategoriesQuery,
} from 'src/graphql/generated/graphql';

interface CategoriesProps {
  field: ControllerRenderProps<any, 'questionCategoryId'>;
  hasError: boolean;
  className?: string;
  disabled?: boolean;
}

export const CategoriesField = ({
  field,
  hasError,
  className,
  disabled,
}: CategoriesProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'wttp.question',
  });

  const { data: categories } = useQuery<WttpQuestionCategoriesQuery>(
    WttpQuestionCategoriesDocument,
    {
      variables: {
        pagination: {
          limit: 100,
          offset: 0,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );

  const categoriesOptions = useMemo(
    () =>
      (categories?.wttpQuestionCategories?.records || []).map((category) => ({
        value: category.id,
        name: category.name ?? '',
      })) ?? [],
    [categories],
  );

  return (
    <Select
      className={className}
      displayEmpty
      options={categoriesOptions}
      error={hasError}
      placeholder={t('form.category-name')}
      defaultValue={field.value}
      {...field}
      disabled={disabled}
      value={undefined}
      ref={undefined}
      inputRef={field.ref}
    />
  );
};
